import { useT } from "../i18n/index.js";

/** Role comes from the authenticated server DTO, never from a name or cosmetic title. */
export function GmBadge({ role }: { role: string }) {
  const t = useT();
  return role === "admin" ? <span className="gm-badge" title={t("social.gm.title")} aria-label={t("social.gm.title")} data-testid="gm-badge">{t("social.gm")}</span> : null;
}
